module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--3-c13c1908.png";